export default __webpack_public_path__ + "static/media/logo01high.aa566fa1.png";